const defaultGridItemProps: {
  width?: number;
  height?: number;
} = {};

export const gridItem = ({ width, height } = defaultGridItemProps) => ({
  gridColumn: width ? `span ${width}` : undefined,
  gridRow: height ? `span ${height}` : undefined,
  // Grid items default to a min-content automatic minimum size, which pins
  // the track to the width of a fixed-size child (e.g. a chart's rendered
  // SVG) and stops the whole grid from ever shrinking again.
  minWidth: 0,
  minHeight: 0,
});
